export default __webpack_public_path__ + "static/media/my-data.fe436aac.svg";